import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/internal/Observable';
import { Pagination } from 'src/app/shared/models';
import { GenericCRUDService } from 'src/app/shared/services';

@Injectable({
    providedIn: 'root'
})
export class RegiaoAdminService extends GenericCRUDService {

    constructor(http: HttpClient) {
        super(http);
        this.url = `/admin/regiao-administrativa`;
    }

    override getPaginated<RegiaoAdmin>(page: number, pageSize: number, nome?: string): Observable<Pagination<RegiaoAdmin>> {
        const params = new URLSearchParams();
        params.append('page', `${page}`);
        params.append('pageSize', `${pageSize}`);
        nome && params.append('nome', `${nome}`);
        return this.http.get<Pagination<RegiaoAdmin>>(`${this.url}?${params}`);
    }
}

